import moment from 'moment';

const Utils = {
    apply: (target, object) => {
        let key = Object.keys(object).find(k => isNaN(k) ? k === target : parseFloat(k) === target);
        return key && typeof(object[key]) === 'function' ? object[key]() : (typeof(object.default) === 'function' ? object.default() : null);
    },
    attributeForKey: {
        select: (e, key) => {
            let optionElement = e.target.childNodes[e.target.selectedIndex];
            return optionElement.getAttribute(key);
        }
    },
    conformDate: (date, interval) => {
        let targetDate = date || moment();
        let minutes = parseInt(moment(targetDate).format('mm'));
        if(minutes % interval === 0) {
            return moment(targetDate);
        }

        let decimal = minutes % interval;
        let offset = interval - decimal;
        return moment(targetDate).add(offset, 'minutes');
    },
    convertBytes: (bytes, decimals) => {
        if(isNaN(bytes) || bytes === 0) {
            return '0 Bytes';
        }

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    formatAddress: (props = {}) => {
        let { address, city, country, state, zipcode } = props;
        if(!address || !city || !country || !state || !zipcode) {
            return 'Not Available';
        }
        return `${address}. ${city}, ${state}. ${zipcode} ${country}`
    },
    formatPhoneNumber: phoneNumber => {
        let cleaned = ('' + phoneNumber).replace(/\D/g, '');
        let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if(match) {
            var intlCode = (match[1] ? '+1 ' : '');
            return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
        }
        return phoneNumber;
    },
    hexToRGBA: (hex, alpha) => {

        var c;
    	if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    		c= hex.substring(1).split('');
    		if(c.length === 3){
    			c= [c[0], c[0], c[1], c[1], c[2], c[2]];
    		}
    		c= '0x'+c.join('');
    		return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',' + alpha + ')';
    	}
    	return hex;
    },
    isMobile: () => {
        return window.innerWidth < 767.98;
    },
    lcFirst: text => {
        return text ? (text.charAt(0).toLowerCase() + text.substring(1)) : '';
    },
    numberFormat: value => {
        if(value > 1000000) {
            return `${(parseFloat(value) / 1000000).toFixed(2)} M`;
        }
        if(value > 1000) {
            return `${(parseFloat(value) / 1000).toFixed(2)} K`;
        }
        return value % 1 !== 0 ? parseFloat(value).toFixed(1) : value;
    },
    parseDuration: duration => {

        let d = parseInt(duration || 0);
        let h = Math.floor(d / 3600);
        let m = Math.floor(d % 3600 / 60);
        let s = Math.floor(d % 3600 % 60);

        var hours = h > 0 ? h + (h === 1 ? ' hour':' hours') : null;
        var minutes = m > 0 ? m + (m === 1 ? ' minute':' minutes') : null;
        if(h >= 24) {
            let _hours = h - 24;
            let days = parseInt(Math.floor(h / 24));
            let string = `${days} ${days === 1 ? 'day':'days'}`;
            if(_hours > 0 && minutes) {
                string += `, ${_hours} ${_hours === 1 ? 'hour':'hours'}, and ${minutes}`;
            } else if(_hours) {
                string += ` and ${_hours} ${_hours === 1 ? 'hour':'hours'}`;
            } else if(minutes) {
                string += ` and ${minutes}`;
            }
            return string;
        } else if(hours && minutes) {
            return hours + ' and ' + minutes;
        } else if(hours) {
            return hours;
        } else if(m > 1) {
            return minutes;
        }
        return s + ' seconds';
    },
    sleep: async seconds => {
        return new Promise(resolve => {
            setTimeout(resolve, (seconds * 1000));
        })
    },
    softNumberFormat: (val, digits = 0) => {
        return parseFloat(val).toLocaleString('en-US', { minimumFractionDigits: digits })
    },
    toCurrency: (value, currency) => {
        return parseFloat(value || 0).toLocaleString('en-US', {
            style: 'currency',
            currency: currency || 'USD'
        })
    },
    toOrdinalString: i => {
        if(isNaN(i)) {
            return i;
        }
        let j = i % 10,
        k = i % 100;
        if (j == 1 && k != 11) {
            return i + 'st';
        }
        if (j == 2 && k != 12) {
            return i + 'nd';
        }
        if (j == 3 && k != 13) {
            return i + 'rd';
        }
        return i + 'th';
    },
    ucFirst: text => {
        return text ? (text.charAt(0).toUpperCase() + text.substring(1)) : '';
    },
    validate: {
        date: date => {
            return date ? moment(date).isValid() : false;
        },
        email: text => {
            return text ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(text) : false;
        },
        phone: text => {
            return text ? /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(text) : false;
        }
    }
}
export default Utils;
